import React, { useState } from "react";
import { Box, Typography, Divider } from "@mui/material";
import { PageLayout } from "../Page";
import QueueDashboard from "./QueueDashboard";
import JobsList from "./JobsList";

const BullMQMonitor = () => {
  const [selectedQueue, setSelectedQueue] = useState(null);

  return (
    <PageLayout>
      <Box p={3}>
        <Typography variant="h4" gutterBottom>
          BullMQ Job Monitor
        </Typography>

        <QueueDashboard
          onQueueSelect={setSelectedQueue}
          selectedQueue={selectedQueue}
        />

        <Divider sx={{ my: 3 }} />

        <JobsList queueName={selectedQueue} />
      </Box>
    </PageLayout>
  );
};

export default BullMQMonitor;
